var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarThing1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 179,
    viewBox: "0 0 139 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 4.34375C69.5 4.34375 70.6556 48.8693 88.2713 67.7546C103.16 83.7161 139 91.2187 139 91.2187C139 91.2187 103.16 98.7214 88.2713 114.683C70.6556 133.568 69.5 178.094 69.5 178.094C69.5 178.094 68.3444 133.568 50.7287 114.683C35.8403 98.7214 0 91.2187 0 91.2187C0 91.2187 35.8403 83.7161 50.7287 67.7546C68.3444 48.8693 69.5 4.34375 69.5 4.34375Z",
    fill: "#DBF429"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5 0C69.5 0 70.6556 44.5255 88.2713 63.4109C103.16 79.3723 139 86.875 139 86.875C139 86.875 103.16 94.3776 88.2713 110.339C70.6556 129.224 69.5 173.75 69.5 173.75C69.5 173.75 68.3444 129.224 50.7287 110.339C35.8403 94.3776 0 86.875 0 86.875C0 86.875 35.8403 79.3723 50.7287 63.4109C68.3444 44.5255 69.5 0 69.5 0Z",
    fill: "#FE3176"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarThing1);
export default __webpack_public_path__ + "static/media/star_thing_1.bf3ec58b.svg";
export { ForwardRef as ReactComponent };